// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    applicationId: z.string().min(1).max(21),
    scopeId: z.string().min(1).max(21),
});
const guard = z.object({
    tenantId: z.string().max(21),
    applicationId: z.string().min(1).max(21),
    scopeId: z.string().min(1).max(21),
});
export const ApplicationUserConsentOrganizationResourceScopes = Object.freeze({
    table: 'application_user_consent_organization_resource_scopes',
    tableSingular: 'application_user_consent_organization_resource_scope',
    fields: {
        tenantId: 'tenant_id',
        applicationId: 'application_id',
        scopeId: 'scope_id',
    },
    fieldKeys: [
        'tenantId',
        'applicationId',
        'scopeId',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
